import { useEffect, useState } from 'react';

const useWindowScrollPosition = () => {
  const [scrollPos, setScrollPos] = useState({ x: 0, y: 0 });
  const handleScroll = () => setScrollPos({ x: window.scrollX, y: window.scrollY });

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, false);
    return () => window.removeEventListener('scroll', handleScroll, false);
  }, []);

  return scrollPos;
};

export default useWindowScrollPosition;
